import { render, staticRenderFns } from "./Ingressar2.vue?vue&type=template&id=37ac9ff3&scoped=true&lang=pug&"
import script from "./Ingressar2.vue?vue&type=script&lang=js&"
export * from "./Ingressar2.vue?vue&type=script&lang=js&"
import style0 from "./Ingressar2.styl?vue&type=style&index=0&id=37ac9ff3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ac9ff3",
  null
  
)

export default component.exports